const offers = [
    {
        "id": "1302902",
        "imageId": "rng/md/carousel/production/42e8d8218a3884aeb15119633af6ed5b",
        "action": {
        "link": "https://www.swiggy.com/collections/96594?collection_id=96594&tags=layout_ux4&type=rcv2",
        "text": "All new super",
        "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
        "altText": "GET 50% OFF ON FIRST ORDER",
        "altTextCta": "ORDER NOW"
        },
        "entityId": "96594",
        "frequencyCapping": {}
        },
        {
        "id": "1308784",
        "imageId": "rng/md/carousel/production/418d1dffd73254b1a580def7e0fe9a4b",
        "action": {
        "link": "https://www.swiggy.com/collections/96734?collection_id=96734&type=rcv2",
        "text": "Holi",
        "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
        "altText": "Flat deals",
        "altTextCta": "order now"
        },
        "entityId": "swiggy://collectionV2?collection_id=96734",
        "frequencyCapping": {}
        },
        {
        "id": "1308216",
        "imageId": "rng/md/carousel/production/8cf596d2dd00cfee9f5ab055d55f1cd9",
        "action": {
        "link": "https://www.swiggy.com/menu/85089",
        "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
        "altText": "Brands with Offers",
        "altTextCta": "open"
        },
        "entityId": "85089",
        "frequencyCapping": {},
        "isManualAds": true
        },
        {
        "id": "1307330",
        "imageId": "rng/md/carousel/production/90b990bd1dc16bba234f5002627f71d3",
        "action": {
        "link": "https://www.swiggy.com/menu/207998",
        "text": "Burger King",
        "type": "WEBLINK"
        },
        "entityType": "BANNER",
        "accessibility": {
        "altText": "Burger King",
        "altTextCta": "Order Now"
        },
        "entityId": "207998",
        "frequencyCapping": {},
        "isManualAds": true
        }
]

export default offers